import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from 'constants/constants';
import { getProductDashboardItems } from 'helpers/backend_helper';
import { Loader2 } from 'lucide-react';

const CustomerCatalog = () => {
  const [categories, setCategories] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      const response = await getProductDashboardItems();
      if (response.success && response.data?.[0]) {
        setCategories(response.data[0].categories || []);
      }
    } catch (error) {
      console.error('Error loading categories', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Loader2 className="size-12 animate-spin text-custom-500" />
      </div>
    );
  }

  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold text-slate-800 dark:text-zink-100">
        Catalog
      </h1>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {categories.map((cat: any) => (
          <Link
            key={cat.id}
            to={`/customer/products?categoryId=${cat.id}`}
            className="group overflow-hidden rounded-xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-custom-500 hover:shadow-md dark:border-zink-500 dark:bg-zink-700"
          >
            <div className="mb-4 flex aspect-square items-center justify-center overflow-hidden rounded-lg bg-slate-100 dark:bg-zink-600">
              {cat.logo ? (
                <img
                  src={getImageUrl(cat.logo, 'categoryThumbnail')}
                  alt={cat.name}
                  className="h-full w-full object-cover"
                />
              ) : (
                <span className="text-5xl font-bold text-slate-400">{cat.name?.charAt(0) || '?'}</span>
              )}
            </div>
            <h3 className="text-center font-medium text-slate-800 group-hover:text-custom-500 dark:text-zink-100">
              {cat.name}
            </h3>
          </Link>
        ))}
      </div>
      {categories.length === 0 && (
        <section className="rounded-lg border border-dashed border-slate-300 py-16 text-center text-slate-500 dark:border-zink-500 dark:text-zink-400">
          No categories available.
        </section>
      )}
    </div>
  );
};

export default CustomerCatalog;
